// extracted by mini-css-extract-plugin
export default {"loadingContainer":"cPvzD8_Ps","container":"cldpLx0hy","content":"cxO4kWgcJ","closeButton":"c3ALzMkFu","textButton":"cExXm_6kJ"};